import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { BlocoPayload, emptyBloco } from "../types";

export const CSV_HEADERS = ["Nome", "Blocos"];

const CSV_EXAMPLES = [
  ["Bloco exemplo 01", "192.168.0.0/24"],
  ["Bloco exemplo 02", "10.0.0.0/22, 10.0.4.0/22"],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  nome: "nome",
  name: "nome",
  nomedobloco: "nome",
  blocos: "blocos",
  bloco: "blocos",
  prefixos: "blocos",
  prefixo: "blocos",
  cidr: "blocos",
};

export function blocosFromCsv(text: string): BlocoPayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyBloco,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template Blocos.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
